import { useEffect, useState } from "react";
import AddFilter from "./AddFilter";
import { useDispatch, useSelector } from "react-redux";
import userProfileSelectors from '../../../../../../redux/UserProfile/selectors'
import SuccessBee from "../../../../../assets/images/SuccessBee.svg";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import {  deleteBudgetingPercentOption, deleteUsefulLifeOption, getCatalogRemoveCapacity, getCatalogRemoveDriveTrain, getCatalogRemoveEqClassCode, getCatalogRemoveMake, getCatalogRemoveStateAvailability, getCatalogRemoveNoOfDoor, getCatalogRemovePowerType, getCatalogRemoveUpfit, getCatalogRemoveVehicleLevel, getCatalogRemoveYear, getCatalogUpdateCapacitySave, getCatalogUpdateCapacityValidate, getCatalogUpdateDriveTrainSave, getCatalogUpdateDriveTrainValidate, getCatalogUpdateEqClassCodeSave, getCatalogUpdateMakeSave, getCatalogUpdateMakeValidate, getCatalogUpdateStateAvailabilitySave, getCatalogUpdateStateAvailabilityValidate, getCatalogUpdateNoOfDoorSave, getCatalogUpdateNoOfDoorValidate, getCatalogUpdatePowerTypeSave, getCatalogUpdatePowerTypeValidate, getCatalogUpdateUpfitSave, getCatalogUpdateUpfitValidate, getCatalogUpdateVehicleLevelSave, getCatalogUpdateVehicleLevelValidate, getCatalogUpdateYearSave, getCatalogUpdateYearValidate, isBudgetingPercentOptionDeleted, isBudgetingPercentOptionSaved, isBudgetingPercentOptionValid, isUsefulLifeOptionDeleted, isUsefulLifeOptionSaved, isUsefulLifeOptionValid, saveBudgetingPercentOption, saveUsefulLifeOption, setCatalogRemoveCapacity, setCatalogRemoveDriveTrain, setCatalogRemoveEqClassCode, setCatalogRemoveMake, setCatalogRemoveStateAvailability, setCatalogRemoveNoOfDoor, setCatalogRemovePowerType, setCatalogRemoveUpfit, setCatalogRemoveVehicleLevel, setCatalogRemoveYear, setCatalogUpdateCapacitySave, setCatalogUpdateCapacityValidate, setCatalogUpdateDriveTrainSave, setCatalogUpdateDriveTrainValidate, setCatalogUpdateEqClassCodeSave, setCatalogUpdateEqClassCodeValidate, setCatalogUpdateMakeSave, setCatalogUpdateMakeValidate, setCatalogUpdateStateAvailabilitySave, setCatalogUpdateStateAvailabilityValidate, setCatalogUpdateNoOfDoorSave, setCatalogUpdateNoOfDoorValidate, setCatalogUpdatePowerTypeSave, setCatalogUpdatePowerTypeValidate, setCatalogUpdateUpfitSave, setCatalogUpdateUpfitValidate, setCatalogUpdateVehicleLevelSave, setCatalogUpdateVehicleLevelValidate, setCatalogUpdateYearSave, setCatalogUpdateYearValidate, validateBudgetingPercentOption, validateUsefulLifeOption, setCatalogUpdateProgramStatusSave, setCatalogRemoveProgramStatus, getCatalogUpdateProgramStatusSave, setCatalogUpdateProgramStatusValidate, getCatalogUpdateProgramStatusValidate, getCatalogRemoveProgramStatus, setCatalogUpdateAnnualHoursSave, setCatalogRemoveAnnualHours, getCatalogUpdateAnnualHoursSave, setCatalogUpdateAnnualHoursValidate, getCatalogUpdateAnnualHoursValidate, getCatalogRemoveAnnualHours, getCatalogRemoveDeckSize, getCatalogUpdateDeckSizeValidate, setCatalogUpdateDeckSizeValidate, getCatalogUpdateDeckSizeSave, setCatalogRemoveDeckSize, setCatalogUpdateDeckSizeSave, getCatalogRemoveDeckType, getCatalogUpdateDeckTypeValidate, setCatalogUpdateDeckTypeValidate, getCatalogUpdateDeckTypeSave, setCatalogRemoveDeckType, setCatalogUpdateDeckTypeSave, setCatalogUpdateSizeSave, setCatalogRemoveSize, getCatalogUpdateSizeSave, setCatalogUpdateSizeValidate, getCatalogUpdateSizeValidate, getCatalogRemoveSize, setCatalogUpdateLengthSave, setCatalogRemoveLength, getCatalogUpdateLengthSave, setCatalogUpdateLengthValidate, getCatalogUpdateLengthValidate, getCatalogRemoveLength, setCatalogUpdateAutonomousSave, setCatalogRemoveAutonomous, getCatalogUpdateAutonomousSave, setCatalogUpdateAutonomousValidate, getCatalogUpdateAutonomousValidate, getCatalogRemoveAutonomous, setCatalogUpdateCategorySave, setCatalogRemoveCategory, getCatalogUpdateCategorySave, setCatalogUpdateCategoryValidate, getCatalogUpdateCategoryValidate, getCatalogRemoveCategory, setCatalogUpdateCategoryTypeSave, setCatalogRemoveCategoryType, getCatalogUpdateCategoryTypeSave, setCatalogUpdateCategoryTypeValidate, getCatalogUpdateCategoryTypeValidate, getCatalogRemoveCategoryType, setCatalogUpdateCategory2Validate, setCatalogUpdateCategory2Save, setCatalogRemoveCategory2, getCatalogUpdateCategory2Save, getCatalogUpdateCategory2Validate, getCatalogRemoveCategory2, setCatalogUpdateTypeSave, setCatalogRemoveType, getCatalogUpdateTypeSave, setCatalogUpdateTypeValidate, getCatalogUpdateTypeValidate, getCatalogRemoveType, deleteTagsOption, validateTagsOption, isTagsOptionValid, saveTagsOption, isTagsOptionDeleted, isTagsOptionSaved, getCatalogUpdateVehicleClassSave, setCatalogUpdateVehicleClassSave, getCatalogUpdateVehicleClassValidate, setCatalogUpdateVehicleClassValidate, getCatalogRemoveVehicleClass, setCatalogRemoveVehicleClass, setCatalogUpdateGroupTypeSave, setCatalogRemoveGroupType, getCatalogUpdateGroupTypeSave, setCatalogUpdateGroupTypeValidate, getCatalogUpdateGroupTypeValidate, getCatalogRemoveGroupType, setCatalogRemoveClassType, setCatalogUpdateClassTypeValidate, getCatalogUpdateClassTypeSave, getCatalogUpdateClassTypeValidate, getCatalogRemoveClassType, setCatalogUpdateClassTypeSave, setCatalogUpdateGrossWeightSave, setCatalogRemoveGrossWeight, getCatalogUpdateGrossWeightSave, getCatalogRemoveGrossWeight, setCatalogUpdateGrossWeightValidate, getCatalogUpdateGrossWeightValidate, setCatalogUpdateTrimSave, setCatalogRemoveTrim, getCatalogUpdateTrimSave, setCatalogUpdateTrimValidate, getCatalogUpdateTrimValidate, getCatalogRemoveTrim } from "Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateAction";
import { AttributeName, CONSTANTS } from "client/utils/constants";
import { addFilterGetData, popupInitialData } from "utils";
import { getIsCatalogItemValidDelete, getIsEqClassValidDelete, getIsVehicleLevelValidDelete, setIsCatalogItemValidDelete, setIsEqClassValidDelete, setIsVehicleLevelValidDelete } from "Store/AssetManagement/CatalogItem/CatalogItemAction";
import permissions, { isAuthorized } from "client/utils/Permissions";

const AddFilterContainer = (props: any) => {
    const {
        ExistingDropDownValue,
        filterName,
        catalogItemValues,
        setFilterModelPopup,
        setFieldValueError,
        fieldValueError,
        selectedAssetType
    } = props

    const {
        userData,
        isCatalogUpdateNoOfDoorSaved,
        isCatalogNoOfDoorRemoved,
        isCatalogUpdateNoOfDoorValid,
        isCatalogUpdateYearValid,
        isCatalogYearRemoved,
        isCatalogUpdateYearSaved,
        isCatalogUpdateCapacityValid,
        isCatalogCapacityRemoved,
        isCatalogUpdateCapacitySaved,
        isCatalogUpdateUpfitValid,
        isCatalogUpfitRemoved,
        isCatalogUpdateUpfitSaved,
        isCatalogUpdateDriveTrainValid,
        isCatalogDriveTrainRemoved,
        isCatalogUpdateDriveTrainSaved,
        isCatalogUpdatePowerTypeValid,
        isCatalogPowerTypeRemoved,
        isCatalogUpdatePowerTypeSaved,
        isCatalogUpdateVehicleLevelValid,
        isCatalogVehicleLevelRemoved,
        isCatalogUpdateVehicleLevelSaved,
        isCatalogUpdateEqClassCodeValid,
        isCatalogEqClassCodeRemoved,
        isCatalogUpdateEqClassCodeSaved,
        isCatalogUpdateMakeValid,
        isCatalogMakeRemoved,
        isCatalogUpdateMakeSaved,
        isCatalogUpdateStateAvailabilityValid,
        isCatalogStateAvailabilityRemoved,
        isCatalogUpdateStateAvailabilitySaved,
        isBudgetingPercentOptionsSaved,
        isBudgetingPercentOptionsValid,
        isBudgetingPercentOptionsDeleted,
        isUsefulLifeOptionsSaved,
        isUsefulLifeOptionsValid,
        isUsefulLifeOptionsDeleted,
        isCatalogUpdateProgramStatusValid,
        isCatalogProgramStatusRemoved,
        isCatalogUpdateProgramStatusSaved,
        isCatalogUpdateAnnualHoursValid,
        isCatalogAnnualHoursRemoved,
        isCatalogUpdateAnnualHoursSaved,
        isCatalogUpdateDeckSizeValid,
        isCatalogDeckSizeRemoved,
        isCatalogUpdateDeckSizeSaved,
        isCatalogUpdateDeckTypeValid,
        isCatalogDeckTypeRemoved,
        isCatalogUpdateDeckTypeSaved,
        isCatalogUpdateSizeValid,
        isCatalogSizeRemoved,
        isCatalogUpdateSizeSaved,
        isCatalogUpdateLengthValid,
        isCatalogLengthRemoved,
        isCatalogUpdateLengthSaved,
        isCatalogUpdateAutonomousValid,
        isCatalogAutonomousRemoved,
        isCatalogUpdateAutonomousSaved,
        isCatalogUpdateCategoryValid,
        isCatalogCategoryRemoved,
        isCatalogUpdateCategorySaved,
        isCatalogUpdateCategoryTypeValid,
        isCatalogCategoryTypeRemoved,
        isCatalogUpdateCategoryTypeSaved,
        isCatalogUpdateCategory2Valid,
        isCatalogCategory2Removed,
        isCatalogUpdateCategory2Saved,
        isCatalogUpdateTypeValid,
        isCatalogTypeRemoved,
        isCatalogUpdateTypeSaved,
        isTagsOptionsSaved,
        isTagsOptionsValid,
        isTagsOptionsDeleted,
        isCatalogUpdateVehicleClassSaved,
        isCatalogUpdateVehicleClassValid,
        isCatalogVehicleClassRemoved,
        isCatalogUpdateGroupTypeSaved,
        isCatalogUpdateGroupTypeValid,
        isCatalogGroupTypeRemoved,
        isCatalogUpdateGrossWeightSaved,
        isCatalogUpdateGrossWeightValid,
        isCatalogGrossWeightRemoved,
        isCatalogUpdateClassTypeSaved,
        isCatalogUpdateClassTypeValid,
        isCatalogClassTypeRemoved,
        isCatalogUpdateTrimSaved,
        isCatalogUpdateTrimValid,
        isCatalogTrimRemoved,
        isCatalogItemValidForDelete,
        isVehicleLevelValidForDelete,
        isEqClassValidForDelete
    }: any = useSelector(
        (state: any) => ({
            userData: userProfileSelectors.getUserDetails(state),
            isCatalogUpdateNoOfDoorSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateNoOfDoorSaved,
            isCatalogNoOfDoorRemoved: state.CatalogDropDownUpdateReducers.isCatalogNoOfDoorRemoved,
            isCatalogUpdateNoOfDoorValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateNoOfDoorValid,
            isCatalogUpdateYearValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateYearValid,
            isCatalogYearRemoved: state.CatalogDropDownUpdateReducers.isCatalogYearRemoved,
            isCatalogUpdateYearSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateYearSaved,
            isCatalogUpdateCapacityValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateCapacityValid,
            isCatalogCapacityRemoved: state.CatalogDropDownUpdateReducers.isCatalogCapacityRemoved,
            isCatalogUpdateCapacitySaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateCapacitySaved,
            isCatalogUpdateUpfitValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateUpfitValid,
            isCatalogUpfitRemoved: state.CatalogDropDownUpdateReducers.isCatalogUpfitRemoved,
            isCatalogUpdateUpfitSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateUpfitSaved,
            isCatalogUpdateDriveTrainValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateDriveTrainValid,
            isCatalogDriveTrainRemoved: state.CatalogDropDownUpdateReducers.isCatalogDriveTrainRemoved,
            isCatalogUpdateDriveTrainSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateDriveTrainSaved,
            isCatalogUpdatePowerTypeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdatePowerTypeValid,
            isCatalogPowerTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogPowerTypeRemoved,
            isCatalogUpdatePowerTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdatePowerTypeSaved,
            isCatalogUpdateVehicleLevelValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateVehicleLevelValid,
            isCatalogVehicleLevelRemoved: state.CatalogDropDownUpdateReducers.isCatalogVehicleLevelRemoved,
            isCatalogUpdateVehicleLevelSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateVehicleLevelSaved,
            isCatalogUpdateEqClassCodeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateEqClassCodeValid,
            isCatalogEqClassCodeRemoved: state.CatalogDropDownUpdateReducers.isCatalogEqClassCodeRemoved,
            isCatalogUpdateEqClassCodeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateEqClassCodeSaved,
            isCatalogUpdateMakeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateMakeValid,
            isCatalogMakeRemoved: state.CatalogDropDownUpdateReducers.isCatalogMakeRemoved,
            isCatalogUpdateMakeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateMakeSaved,
            isCatalogUpdateStateAvailabilityValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateStateAvailabilityValid,
            isCatalogStateAvailabilityRemoved: state.CatalogDropDownUpdateReducers.isCatalogStateAvailabilityRemoved,
            isCatalogUpdateStateAvailabilitySaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateStateAvailabilitySaved,
            isBudgetingPercentOptionsSaved: state.CatalogDropDownUpdateReducers.isBudgetingPercentOptionsSaved,
            isBudgetingPercentOptionsValid: state.CatalogDropDownUpdateReducers.isBudgetingPercentOptionsValid,
            isBudgetingPercentOptionsDeleted: state.CatalogDropDownUpdateReducers.isBudgetingPercentOptionsDeleted,
            isUsefulLifeOptionsSaved: state.CatalogDropDownUpdateReducers.isUsefulLifeOptionsSaved,
            isUsefulLifeOptionsValid: state.CatalogDropDownUpdateReducers.isUsefulLifeOptionsValid,
            isUsefulLifeOptionsDeleted: state.CatalogDropDownUpdateReducers.isUsefulLifeOptionsDeleted,
            isCatalogUpdateProgramStatusValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateProgramStatusValid,
            isCatalogProgramStatusRemoved: state.CatalogDropDownUpdateReducers.isCatalogProgramStatusRemoved,
            isCatalogUpdateProgramStatusSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateProgramStatusSaved,
            isCatalogUpdateAnnualHoursValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateAnnualHoursValid,
            isCatalogAnnualHoursRemoved: state.CatalogDropDownUpdateReducers.isCatalogAnnualHoursRemoved,
            isCatalogUpdateAnnualHoursSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateAnnualHoursSaved,
            isCatalogUpdateDeckSizeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateDeckSizeValid,
            isCatalogDeckSizeRemoved: state.CatalogDropDownUpdateReducers.isCatalogDeckSizeRemoved,
            isCatalogUpdateDeckSizeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateDeckSizeSaved,
            isCatalogUpdateDeckTypeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateDeckTypeValid,
            isCatalogDeckTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogDeckTypeRemoved,
            isCatalogUpdateDeckTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateDeckTypeSaved,
            isCatalogUpdateSizeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateSizeValid,
            isCatalogSizeRemoved: state.CatalogDropDownUpdateReducers.isCatalogSizeRemoved,
            isCatalogUpdateSizeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateSizeSaved,
            isCatalogUpdateLengthValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateLengthValid,
            isCatalogLengthRemoved: state.CatalogDropDownUpdateReducers.isCatalogLengthRemoved,
            isCatalogUpdateLengthSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateLengthSaved,
            isCatalogUpdateAutonomousValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateAutonomousValid,
            isCatalogAutonomousRemoved: state.CatalogDropDownUpdateReducers.isCatalogAutonomousRemoved,
            isCatalogUpdateAutonomousSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateAutonomousSaved,
            isCatalogUpdateCategoryValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateCategoryValid,
            isCatalogCategoryRemoved: state.CatalogDropDownUpdateReducers.isCatalogCategoryRemoved,
            isCatalogUpdateCategorySaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateCategorySaved,
            isCatalogUpdateCategoryTypeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateCategoryTypeValid,
            isCatalogCategoryTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogCategoryTypeRemoved,
            isCatalogUpdateCategoryTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateCategoryTypeSaved,
            isCatalogUpdateCategory2Valid: state.CatalogDropDownUpdateReducers.isCatalogUpdateCategory2Valid,
            isCatalogCategory2Removed: state.CatalogDropDownUpdateReducers.isCatalogCategory2Removed,
            isCatalogUpdateCategory2Saved: state.CatalogDropDownUpdateReducers.isCatalogUpdateCategory2Saved,
            isCatalogUpdateTypeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateTypeValid,
            isCatalogTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogTypeRemoved,
            isCatalogUpdateTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateTypeSaved,
            isTagsOptionsValid: state.CatalogDropDownUpdateReducers.isTagsOptionsValid,
            isTagsOptionsSaved: state.CatalogDropDownUpdateReducers.isTagsOptionsSaved,
            isTagsOptionsDeleted: state.CatalogDropDownUpdateReducers.isTagsOptionsDeleted,
            isCatalogUpdateVehicleClassSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateVehicleClassSaved,
            isCatalogUpdateVehicleClassValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateVehicleClassValid,
            isCatalogVehicleClassRemoved: state.CatalogDropDownUpdateReducers.isCatalogVehicleClassRemoved,
            isCatalogUpdateGroupTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateGroupTypeSaved,
            isCatalogUpdateGroupTypeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateGroupTypeValid,
            isCatalogGroupTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogGroupTypeRemoved,
            isCatalogUpdateGrossWeightSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateGrossWeightSaved,
            isCatalogUpdateGrossWeightValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateGrossWeightValid,
            isCatalogGrossWeightRemoved: state.CatalogDropDownUpdateReducers.isCatalogGrossWeightRemoved,
            isCatalogUpdateClassTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateClassTypeSaved,
            isCatalogUpdateClassTypeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateClassTypeValid,
            isCatalogClassTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogClassTypeRemoved,
            isCatalogUpdateTrimSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateTrimSaved,
            isCatalogUpdateTrimValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateTrimValid,
            isCatalogTrimRemoved: state.CatalogDropDownUpdateReducers.isCatalogTrimRemoved,
            isCatalogItemValidForDelete: state.CatalogItemReducer.isCatalogItemValidForDelete,
            isVehicleLevelValidForDelete: state.CatalogItemReducer.isVehicleLevelValidForDelete,
            isEqClassValidForDelete: state.CatalogItemReducer.isEqClassValidForDelete
        })
    )

    const dispatch = useDispatch()
    const [fieldValue, setFieldValue] = useState<any>("");
    const [isVehicleCapacityChecked, setIsVehicleCapacityChecked] = useState<any>(false);
    const [PopupcontentComplete, setPopupcontentComplete] = useState<any>(popupInitialData);
    const [deleteTempValue, setDeleteTempValue] = useState<any>(null);

    const hideDialogComplete = () => {
        setPopupcontentComplete({ ...PopupcontentComplete, isDialogVisible: false })
    };

    useEffect(() => {
        if ((isCatalogUpdateNoOfDoorSaved && isCatalogUpdateNoOfDoorSaved != null) ||
            (isCatalogUpdateYearSaved && isCatalogUpdateYearSaved != null) ||
            (isCatalogUpdateCapacitySaved && isCatalogUpdateCapacitySaved != null) ||
            (isCatalogUpdateUpfitSaved && isCatalogUpdateUpfitSaved != null) ||
            (isCatalogUpdateDriveTrainSaved && isCatalogUpdateDriveTrainSaved != null) ||
            (isCatalogUpdatePowerTypeSaved && isCatalogUpdatePowerTypeSaved != null) ||
            (isCatalogUpdateVehicleLevelSaved && isCatalogUpdateVehicleLevelSaved != null) ||
            (isCatalogUpdateEqClassCodeSaved && isCatalogUpdateEqClassCodeSaved != null) ||
            (isCatalogUpdateMakeSaved && isCatalogUpdateMakeSaved != null) ||
            (isCatalogUpdateStateAvailabilitySaved && isCatalogUpdateStateAvailabilitySaved != null) ||
            (isBudgetingPercentOptionsSaved && isBudgetingPercentOptionsSaved != null) ||
            (isUsefulLifeOptionsSaved && isUsefulLifeOptionsSaved != null) ||
            (isTagsOptionsSaved && isTagsOptionsSaved != null) ||
            (isCatalogUpdateProgramStatusSaved && isCatalogUpdateProgramStatusSaved != null) ||
            (isCatalogUpdateAnnualHoursSaved && isCatalogUpdateAnnualHoursSaved != null) ||
            (isCatalogUpdateDeckSizeSaved && isCatalogUpdateDeckSizeSaved != null) ||
            (isCatalogUpdateDeckTypeSaved && isCatalogUpdateDeckTypeSaved != null) ||
            (isCatalogUpdateSizeSaved && isCatalogUpdateSizeSaved != null) ||
            (isCatalogUpdateLengthSaved && isCatalogUpdateLengthSaved != null) ||
            (isCatalogUpdateAutonomousSaved && isCatalogUpdateAutonomousSaved != null) ||
            (isCatalogUpdateCategorySaved && isCatalogUpdateCategorySaved != null) ||
            (isCatalogUpdateCategoryTypeSaved && isCatalogUpdateCategoryTypeSaved != null) ||
            (isCatalogUpdateCategory2Saved && isCatalogUpdateCategory2Saved != null) ||
            (isCatalogUpdateTypeSaved && isCatalogUpdateTypeSaved != null) ||
            (isCatalogUpdateVehicleClassSaved && isCatalogUpdateVehicleClassSaved != null) ||
            (isCatalogUpdateGroupTypeSaved && isCatalogUpdateGroupTypeSaved != null) ||
            (isCatalogUpdateClassTypeSaved && isCatalogUpdateClassTypeSaved != null) ||
            (isCatalogUpdateGrossWeightSaved && isCatalogUpdateGrossWeightSaved != null) ||
            (isCatalogUpdateTrimSaved && isCatalogUpdateTrimSaved != null)
            ) {
            let decriptionTxt = (<p>{filterName == AttributeName.VEHICLE_LEVEL  ? AttributeName.ASSIGNMENT_GROUPS : filterName} is added successfully.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: SuccessBee,
                title: "SUCCESS",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    setFilterModelPopup(false)
                    addFilterGetData(filterName, dispatch, catalogItemValues, selectedAssetType)
                }
            });
        } else if ((!isCatalogUpdateNoOfDoorSaved && isCatalogUpdateNoOfDoorSaved != null) ||
            (!isCatalogUpdateYearSaved && isCatalogUpdateYearSaved != null) ||
            (!isCatalogUpdateCapacitySaved && isCatalogUpdateCapacitySaved != null) ||
            (!isCatalogUpdateUpfitSaved && isCatalogUpdateUpfitSaved != null) ||
            (!isCatalogUpdateDriveTrainSaved && isCatalogUpdateDriveTrainSaved != null) ||
            (!isCatalogUpdatePowerTypeSaved && isCatalogUpdatePowerTypeSaved != null) ||
            (!isCatalogUpdateVehicleLevelSaved && isCatalogUpdateVehicleLevelSaved != null) ||
            (!isCatalogUpdateEqClassCodeSaved && isCatalogUpdateEqClassCodeSaved != null) ||
            (!isCatalogUpdateMakeSaved && isCatalogUpdateMakeSaved != null) ||
            (!isCatalogUpdateStateAvailabilitySaved && isCatalogUpdateStateAvailabilitySaved != null) ||
            (!isBudgetingPercentOptionsSaved && isBudgetingPercentOptionsSaved != null) ||
            (!isUsefulLifeOptionsSaved && isUsefulLifeOptionsSaved != null) ||
            (!isTagsOptionsSaved && isTagsOptionsSaved != null) ||
            (!isCatalogUpdateProgramStatusSaved && isCatalogUpdateProgramStatusSaved != null) ||
            (!isCatalogUpdateAnnualHoursSaved && isCatalogUpdateAnnualHoursSaved != null) ||
            (!isCatalogUpdateDeckSizeSaved && isCatalogUpdateDeckSizeSaved != null) ||
            (!isCatalogUpdateDeckTypeSaved && isCatalogUpdateDeckTypeSaved != null) ||
            (!isCatalogUpdateSizeSaved && isCatalogUpdateSizeSaved != null) ||
            (!isCatalogUpdateLengthSaved && isCatalogUpdateLengthSaved != null) ||
            (!isCatalogUpdateAutonomousSaved && isCatalogUpdateAutonomousSaved != null) ||
            (!isCatalogUpdateCategorySaved && isCatalogUpdateCategorySaved != null) ||
            (!isCatalogUpdateCategoryTypeSaved && isCatalogUpdateCategoryTypeSaved != null) ||
            (!isCatalogUpdateCategory2Saved && isCatalogUpdateCategory2Saved != null) ||
            (!isCatalogUpdateTypeSaved && isCatalogUpdateTypeSaved != null) ||
            (!isCatalogUpdateVehicleClassSaved && isCatalogUpdateVehicleClassSaved != null) ||
            (!isCatalogUpdateGroupTypeSaved && isCatalogUpdateGroupTypeSaved != null) ||
            (!isCatalogUpdateClassTypeSaved && isCatalogUpdateClassTypeSaved != null) ||
            (!isCatalogUpdateGrossWeightSaved && isCatalogUpdateGrossWeightSaved != null) ||
            (!isCatalogUpdateTrimSaved && isCatalogUpdateTrimSaved != null)
            ) {
            let decriptionTxt = (<p>Error Occured while adding the value.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: ConfirmationBee,
                title: "INFORMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    if (filterName == "# of Doors") {
                        dispatch(setCatalogUpdateNoOfDoorSave(null))
                    } else if (filterName == "Year") {
                        dispatch(setCatalogUpdateYearSave(null))
                    } else if(filterName == "Vehicle Class") {
                        dispatch(setCatalogUpdateVehicleClassSave(null))
                    } else if(filterName == "Group Type"){
                        dispatch(setCatalogUpdateGroupTypeSave(null))
                    } else if(filterName == "Gross Vehicle Weight Rating"){
                        dispatch(setCatalogUpdateGrossWeightSave(null))
                    } else if(filterName == "Trim"){
                        dispatch(setCatalogUpdateTrimSave(null))
                    } else if(filterName == "Class Type"){
                        dispatch(setCatalogUpdateClassTypeSave(null))
                    } else if (filterName == "Capacity") {
                        dispatch(setCatalogUpdateCapacitySave(null))
                    } else if (filterName == "Upfit") {
                        dispatch(setCatalogUpdateUpfitSave(null))
                    } else if (filterName == "Drive Train") {
                        dispatch(setCatalogUpdateDriveTrainSave(null))
                    } else if (filterName == "Power Type") {
                        dispatch(setCatalogUpdatePowerTypeSave(null))
                    } else if (filterName == "Vehicle Level") {
                        dispatch(setCatalogUpdateVehicleLevelSave(null))
                    } else if (filterName == "Eq Class Code") {
                        dispatch(setCatalogUpdateEqClassCodeSave(null))
                    } else if (filterName == "Make" || filterName == "Manufacturer") {
                        dispatch(setCatalogUpdateMakeSave(null))
                    } else if (filterName == "State Availability") {
                        dispatch(setCatalogUpdateStateAvailabilitySave(null))
                    } else if (filterName == "Budgeting Percent") {
                        dispatch(isBudgetingPercentOptionSaved(null))
                    } else if (filterName == "Useful Life / Lease Terms") {
                        dispatch(isUsefulLifeOptionSaved(null))
                    } else if (filterName == "Tags") {
                        dispatch(isTagsOptionSaved(null))
                    } else if (filterName == "Program Status") {
                        dispatch(setCatalogUpdateProgramStatusSave(null))
                    } else if (filterName == "Annual Hours") {
                        dispatch(setCatalogUpdateAnnualHoursSave(null))
                    } else if (filterName == "Deck Size") {
                        dispatch(setCatalogUpdateDeckSizeSave(null))
                    } else if (filterName == "Deck Type") {
                        dispatch(setCatalogUpdateDeckTypeSave(null))
                    } else if (filterName == "Size") {
                        dispatch(setCatalogUpdateSizeSave(null))
                    } else if (filterName == "Length") {
                        dispatch(setCatalogUpdateLengthSave(null))
                    } else if (filterName == "Autonomous") {
                        dispatch(setCatalogUpdateAutonomousSave(null))
                    } else if (filterName == "Category") {
                        dispatch(setCatalogUpdateCategorySave(null))
                    } else if (filterName == "Category Type") {
                        dispatch(setCatalogUpdateCategoryTypeSave(null))
                    } else if (filterName == "Category2") {
                        dispatch(setCatalogUpdateCategory2Save(null))
                    } else if (filterName == "Type") {
                        dispatch(setCatalogUpdateTypeSave(null))
                    }
                }
            });
        }
    }, [isCatalogUpdateNoOfDoorSaved, isCatalogUpdateYearSaved, isCatalogUpdateCapacitySaved, isCatalogUpdateUpfitSaved, isCatalogUpdateDriveTrainSaved, isCatalogUpdatePowerTypeSaved, isCatalogUpdateVehicleLevelSaved, isCatalogUpdateEqClassCodeSaved, isCatalogUpdateMakeSaved, isCatalogUpdateStateAvailabilitySaved, isBudgetingPercentOptionsSaved, isUsefulLifeOptionsSaved, isTagsOptionsSaved, isCatalogUpdateProgramStatusSaved, isCatalogUpdateAnnualHoursSaved, isCatalogUpdateDeckSizeSaved, isCatalogUpdateSizeSaved, isCatalogUpdateDeckTypeSaved, isCatalogUpdateLengthSaved, isCatalogUpdateAutonomousSaved, isCatalogUpdateCategorySaved, isCatalogUpdateCategoryTypeSaved, isCatalogUpdateCategory2Saved, isCatalogUpdateTypeSaved, isCatalogUpdateVehicleClassSaved, isCatalogUpdateGroupTypeSaved, isCatalogUpdateClassTypeSaved, isCatalogUpdateGrossWeightSaved, isCatalogUpdateTrimSaved])

    useEffect(() => {
        if ((isCatalogNoOfDoorRemoved && isCatalogNoOfDoorRemoved != null) ||
            (isCatalogYearRemoved && isCatalogYearRemoved != null) ||
            (isCatalogCapacityRemoved && isCatalogCapacityRemoved != null) ||
            (isCatalogUpfitRemoved && isCatalogUpfitRemoved != null) ||
            (isCatalogDriveTrainRemoved && isCatalogDriveTrainRemoved != null) ||
            (isCatalogPowerTypeRemoved && isCatalogPowerTypeRemoved != null) ||
            (isCatalogVehicleLevelRemoved && isCatalogVehicleLevelRemoved != null) ||
            (isCatalogEqClassCodeRemoved && isCatalogEqClassCodeRemoved != null) ||
            (isCatalogMakeRemoved && isCatalogMakeRemoved != null) ||
            (isCatalogStateAvailabilityRemoved && isCatalogStateAvailabilityRemoved != null) ||
            (isBudgetingPercentOptionsDeleted && isBudgetingPercentOptionsDeleted != null) ||
            (isUsefulLifeOptionsDeleted && isUsefulLifeOptionsDeleted != null) ||
            (isTagsOptionsDeleted && isTagsOptionsDeleted != null) ||
            (isCatalogProgramStatusRemoved && isCatalogProgramStatusRemoved != null) ||
            (isCatalogAnnualHoursRemoved && isCatalogAnnualHoursRemoved != null) ||
            (isCatalogDeckSizeRemoved && isCatalogDeckSizeRemoved != null) ||
            (isCatalogDeckTypeRemoved && isCatalogDeckTypeRemoved != null) ||
            (isCatalogSizeRemoved && isCatalogSizeRemoved != null) ||
            (isCatalogLengthRemoved && isCatalogLengthRemoved != null) ||
            (isCatalogAutonomousRemoved && isCatalogAutonomousRemoved != null) ||
            (isCatalogCategoryRemoved && isCatalogCategoryRemoved != null) ||
            (isCatalogCategoryTypeRemoved && isCatalogCategoryTypeRemoved != null) ||
            (isCatalogCategory2Removed && isCatalogCategory2Removed != null) ||
            (isCatalogTypeRemoved && isCatalogTypeRemoved != null) ||
            (isCatalogVehicleClassRemoved && isCatalogVehicleClassRemoved != null) ||
            (isCatalogGroupTypeRemoved && isCatalogGroupTypeRemoved != null) ||
            (isCatalogClassTypeRemoved && isCatalogClassTypeRemoved != null) ||
            (isCatalogGrossWeightRemoved && isCatalogGrossWeightRemoved != null) ||
            (isCatalogTrimRemoved && isCatalogTrimRemoved != null)
            ) {
            let decriptionTxt = (<p>Value is removed successfully.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: SuccessBee,
                title: "SUCCESS",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    addFilterGetData(filterName, dispatch, catalogItemValues, selectedAssetType)
                }
            });
        } else if ((!isCatalogNoOfDoorRemoved && isCatalogNoOfDoorRemoved != null) ||
            (!isCatalogYearRemoved && isCatalogYearRemoved != null) ||
            (!isCatalogCapacityRemoved && isCatalogCapacityRemoved != null) ||
            (!isCatalogUpfitRemoved && isCatalogUpfitRemoved != null) ||
            (!isCatalogDriveTrainRemoved && isCatalogDriveTrainRemoved != null) ||
            (!isCatalogPowerTypeRemoved && isCatalogPowerTypeRemoved != null) ||
            (!isCatalogVehicleLevelRemoved && isCatalogVehicleLevelRemoved != null) ||
            (!isCatalogEqClassCodeRemoved && isCatalogEqClassCodeRemoved != null) ||
            (!isCatalogMakeRemoved && isCatalogMakeRemoved != null) ||
            (!isCatalogStateAvailabilityRemoved && isCatalogStateAvailabilityRemoved != null) ||
            (!isBudgetingPercentOptionsDeleted && isBudgetingPercentOptionsDeleted != null) ||
            (!isUsefulLifeOptionsDeleted && isUsefulLifeOptionsDeleted != null) ||
            (!isTagsOptionsDeleted && isTagsOptionsDeleted != null) ||
            (!isCatalogProgramStatusRemoved && isCatalogProgramStatusRemoved != null) ||
            (!isCatalogAnnualHoursRemoved && isCatalogAnnualHoursRemoved != null) ||
            (!isCatalogDeckSizeRemoved && isCatalogDeckSizeRemoved != null) ||
            (!isCatalogDeckTypeRemoved && isCatalogDeckTypeRemoved != null) ||
            (!isCatalogSizeRemoved && isCatalogSizeRemoved != null) ||
            (!isCatalogLengthRemoved && isCatalogLengthRemoved != null) ||
            (!isCatalogAutonomousRemoved && isCatalogAutonomousRemoved != null) ||
            (!isCatalogCategoryRemoved && isCatalogCategoryRemoved != null) ||
            (!isCatalogCategoryTypeRemoved && isCatalogCategoryTypeRemoved != null) ||
            (!isCatalogCategory2Removed && isCatalogCategory2Removed != null) ||
            (!isCatalogTypeRemoved && isCatalogTypeRemoved != null) ||
            (!isCatalogVehicleClassRemoved && isCatalogVehicleClassRemoved != null) ||
            (!isCatalogGroupTypeRemoved && isCatalogGroupTypeRemoved != null) ||
            (!isCatalogClassTypeRemoved && isCatalogClassTypeRemoved != null) ||
            (!isCatalogGrossWeightRemoved && isCatalogGrossWeightRemoved != null) ||
            (!isCatalogTrimRemoved && isCatalogTrimRemoved != null)
            ) {
            let decriptionTxt = (<p>Error Occured while removing the value.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: ConfirmationBee,
                title: "INFORMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    if (filterName == "# of Doors") {
                        dispatch(setCatalogRemoveNoOfDoor(null))
                    } else if (filterName == "Year") {
                        dispatch(setCatalogRemoveYear(null))
                    } else if (filterName == "Vehicle Class") {
                        dispatch(setCatalogRemoveVehicleClass(null))
                    } else if(filterName == "Group Type"){
                        dispatch(setCatalogRemoveGroupType(null))
                    } else if(filterName == "Gross Vehicle Weight Rating"){
                        dispatch(setCatalogRemoveGrossWeight(null))
                    } else if(filterName == "Trim"){
                        dispatch(setCatalogRemoveTrim(null))
                    } else if(filterName == "Class Type"){
                        dispatch(setCatalogRemoveClassType(null))
                    } else if (filterName == "Capacity") {
                        dispatch(setCatalogRemoveCapacity(null))
                    } else if (filterName == "Upfit") {
                        dispatch(setCatalogRemoveUpfit(null))
                    } else if (filterName == "Drive Train") {
                        dispatch(setCatalogRemoveDriveTrain(null))
                    } else if (filterName == "Power Type") {
                        dispatch(setCatalogRemovePowerType(null))
                    } else if (filterName == "Vehicle Level") {
                        dispatch(setCatalogRemoveVehicleLevel(null))
                    } else if (filterName == "Eq Class Code") {
                        dispatch(setCatalogRemoveEqClassCode(null))
                    } else if (filterName == "Make" || filterName == "Manufacturer") {
                        dispatch(setCatalogRemoveMake(null))
                    } else if (filterName == "State Availability") {
                        dispatch(setCatalogRemoveStateAvailability(null))
                    } else if (filterName == "Budgeting Percent") {
                        dispatch(isBudgetingPercentOptionDeleted(null))
                    } else if (filterName == "Useful Life / Lease Terms") {
                        dispatch(isUsefulLifeOptionDeleted(null))
                    } else if (filterName == "Tags") {
                        dispatch(isTagsOptionDeleted(null))
                    } else if (filterName == "Program Status") {
                        dispatch(setCatalogRemoveProgramStatus(null))
                    } else if (filterName == "Annual Hours") {
                        dispatch(setCatalogRemoveAnnualHours(null))
                    } else if (filterName == "Deck Size") {
                        dispatch(setCatalogRemoveDeckSize(null))
                    } else if (filterName == "Deck Type") {
                        dispatch(setCatalogRemoveDeckType(null))
                    } else if (filterName == "Size") {
                        dispatch(setCatalogRemoveSize(null))
                    } else if (filterName == "Length") {
                        dispatch(setCatalogRemoveLength(null))
                    } else if (filterName == "Autonomous") {
                        dispatch(setCatalogRemoveAutonomous(null))
                    } else if (filterName == "Category") {
                        dispatch(setCatalogRemoveCategory(null))
                    } else if (filterName == "Category Type") {
                        dispatch(setCatalogRemoveCategoryType(null))
                    } else if (filterName == "Category2") {
                        dispatch(setCatalogRemoveCategory2(null))
                    } else if (filterName == "Type") {
                        dispatch(setCatalogRemoveType(null))
                    }
                }
            });
        }
    }, [isCatalogNoOfDoorRemoved, isCatalogYearRemoved, isCatalogCapacityRemoved, isCatalogUpfitRemoved, isCatalogDriveTrainRemoved, isCatalogPowerTypeRemoved, isCatalogVehicleLevelRemoved, isCatalogEqClassCodeRemoved, isCatalogMakeRemoved, isCatalogStateAvailabilityRemoved, isBudgetingPercentOptionsDeleted, isUsefulLifeOptionsDeleted, isTagsOptionsDeleted, isCatalogProgramStatusRemoved, isCatalogAnnualHoursRemoved, isCatalogDeckSizeRemoved, isCatalogDeckTypeRemoved, isCatalogSizeRemoved, isCatalogLengthRemoved, isCatalogAutonomousRemoved, isCatalogCategoryRemoved, isCatalogCategoryTypeRemoved, isCatalogCategory2Removed, isCatalogTypeRemoved, isCatalogVehicleClassRemoved, isCatalogGroupTypeRemoved, isCatalogClassTypeRemoved, isCatalogGrossWeightRemoved, isCatalogTrimRemoved])

    useEffect(() => {
        if ((isCatalogUpdateNoOfDoorValid && isCatalogUpdateNoOfDoorValid != null) ||
            (isCatalogUpdateYearValid && isCatalogUpdateYearValid != null) ||
            (isCatalogUpdateCapacityValid && isCatalogUpdateCapacityValid != null) ||
            (isCatalogUpdateUpfitValid && isCatalogUpdateUpfitValid != null) ||
            (isCatalogUpdateDriveTrainValid && isCatalogUpdateDriveTrainValid != null) ||
            (isCatalogUpdatePowerTypeValid && isCatalogUpdatePowerTypeValid != null) ||
            (isCatalogUpdateVehicleLevelValid && isCatalogUpdateVehicleLevelValid != null) ||
            (isCatalogUpdateEqClassCodeValid && isCatalogUpdateEqClassCodeValid != null) ||
            (isCatalogUpdateMakeValid && isCatalogUpdateMakeValid != null) ||
            (isCatalogUpdateStateAvailabilityValid && isCatalogUpdateStateAvailabilityValid != null) ||
            (isBudgetingPercentOptionsValid && isBudgetingPercentOptionsValid != null) ||
            (isUsefulLifeOptionsValid && isUsefulLifeOptionsValid != null) ||
            (isTagsOptionsValid && isTagsOptionsValid != null) ||
            (isCatalogUpdateProgramStatusValid && isCatalogUpdateProgramStatusValid != null) ||
            (isCatalogUpdateAnnualHoursValid && isCatalogUpdateAnnualHoursValid != null) ||
            (isCatalogUpdateDeckSizeValid && isCatalogUpdateDeckSizeValid != null) ||
            (isCatalogUpdateDeckTypeValid && isCatalogUpdateDeckTypeValid != null) ||
            (isCatalogUpdateSizeValid && isCatalogUpdateSizeValid != null) ||
            (isCatalogUpdateLengthValid && isCatalogUpdateLengthValid != null) ||
            (isCatalogUpdateAutonomousValid && isCatalogUpdateAutonomousValid != null) ||
            (isCatalogUpdateCategoryValid && isCatalogUpdateCategoryValid != null) ||
            (isCatalogUpdateCategoryTypeValid && isCatalogUpdateCategoryTypeValid != null) ||
            (isCatalogUpdateCategory2Valid && isCatalogUpdateCategory2Valid != null) ||
            (isCatalogUpdateTypeValid && isCatalogUpdateTypeValid != null) ||
            (isCatalogUpdateVehicleClassValid && isCatalogUpdateVehicleClassValid != null) ||
            (isCatalogUpdateGroupTypeValid && isCatalogUpdateGroupTypeValid != null) ||
            (isCatalogUpdateClassTypeValid && isCatalogUpdateClassTypeValid != null) ||
            (isCatalogUpdateGrossWeightValid && isCatalogUpdateGrossWeightValid != null) ||
            (isCatalogUpdateTrimValid && isCatalogUpdateTrimValid != null)
            ) {
            if (filterName == "# of Doors") {
                dispatch(getCatalogUpdateNoOfDoorSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId),
                    attributeName: AttributeName.NO_OF_DOORS
                }))
                dispatch(setCatalogUpdateNoOfDoorValidate(null))
            } else if (filterName == "Year") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateYearSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.YEAR
                }))
                dispatch(setCatalogUpdateYearValidate(null))
            } else if (filterName == "Vehicle Class") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateVehicleClassSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.VEHICLE_CLASS
                }))
                dispatch(setCatalogUpdateVehicleClassValidate(null))
            } else if (filterName == "Group Type") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateGroupTypeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.GROUP_TYPE
                }))
                dispatch(setCatalogUpdateGroupTypeValidate(null))
            } else if (filterName == "Gross Vehicle Weight Rating") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateGrossWeightSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.GROSS_WEIGHT_RATING
                }))
                dispatch(setCatalogUpdateGrossWeightValidate(null))
            } else if (filterName == "Trim") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateTrimSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.TRIM
                }))
                dispatch(setCatalogUpdateTrimValidate(null))
            } else if (filterName == "Class Type") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateClassTypeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    showVehicleCapacity: isVehicleCapacityChecked,
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.VEHICLE_TYPE
                }))
                dispatch(setCatalogUpdateClassTypeValidate(null))
            } else if (filterName == "Capacity") {
                dispatch(getCatalogUpdateCapacitySave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId),
                    attributeName: AttributeName.TRUCK_SIZE
                }))
                dispatch(setCatalogUpdateCapacityValidate(null))
            } else if (filterName == "Upfit") {
                dispatch(getCatalogUpdateUpfitSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId),
                    attributeName: AttributeName.UPFIT_OPTION
                }))
                dispatch(setCatalogUpdateUpfitValidate(null))
            } else if (filterName == "Drive Train") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateDriveTrainSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.DRIVE_TRAIN
                }))
                dispatch(setCatalogUpdateDriveTrainValidate(null))
            } else if (filterName == "Power Type") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdatePowerTypeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.FUEL_TYPE
                }))
                dispatch(setCatalogUpdatePowerTypeValidate(null))
            } else if (filterName == "Vehicle Level") {
                dispatch(getCatalogUpdateVehicleLevelSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId),
                    attributeName: "Vehicle Level"
                }))
                dispatch(setCatalogUpdateVehicleLevelValidate(null))
            } else if (filterName == "Eq Class Code") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateEqClassCodeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId)
                }))
                dispatch(setCatalogUpdateEqClassCodeValidate(null))
            } else if (filterName == "Make" || filterName == "Manufacturer") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                let isEquipment = selectedAssetType?.assetType?.value !== CONSTANTS.VEHICLE ? AttributeName.MANUFACTURER : AttributeName.MAKE
                dispatch(getCatalogUpdateMakeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: isEquipment
                }))
                dispatch(setCatalogUpdateMakeValidate(null))
            } else if (filterName == "State Availability") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateStateAvailabilitySave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.STATE_AVAILABILITY
                }))
                dispatch(setCatalogUpdateStateAvailabilityValidate(null))
            } else if (filterName == "Budgeting Percent") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(saveBudgetingPercentOption({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.BUDGETING_PERCENT
                }))
                dispatch(isBudgetingPercentOptionValid(null))
            } else if (filterName == "Useful Life / Lease Terms") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(saveUsefulLifeOption({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.USEFUL_LIFE_LEASE_TERMS
                }))
                dispatch(isUsefulLifeOptionValid(null))
            } else if (filterName == "Tags") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(saveTagsOption({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(subTypeId),
                    attributeName: AttributeName.USE_TAG
                }))
                dispatch(isTagsOptionValid(null))
            } else if (filterName == "Program Status") {
                dispatch(getCatalogUpdateProgramStatusSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeName: AttributeName.PROGRAM_STATUS
                }))
                dispatch(setCatalogUpdateProgramStatusValidate(null))
            } else if (filterName == "Annual Hours") {
                dispatch(getCatalogUpdateAnnualHoursSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeName: AttributeName.ANNUAL_HOURS
                }))
                dispatch(setCatalogUpdateAnnualHoursValidate(null))
            } else if (filterName == "Deck Size") {
                dispatch(getCatalogUpdateDeckSizeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeName: AttributeName.DECKSIZE
                }))
                dispatch(setCatalogUpdateDeckSizeValidate(null))
            } else if (filterName == "Deck Type") {
                dispatch(getCatalogUpdateDeckTypeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeName: AttributeName.DECK_TYPE
                }))
                dispatch(setCatalogUpdateDeckTypeValidate(null))
            } else if (filterName == "Size") {
                dispatch(getCatalogUpdateSizeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeName: AttributeName.SIZE
                }))
                dispatch(setCatalogUpdateSizeValidate(null))
            } else if (filterName == "Length") {
                dispatch(getCatalogUpdateLengthSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeName: AttributeName.LENGTH
                }))
                dispatch(setCatalogUpdateLengthValidate(null))
            } else if (filterName == "Autonomous") {
                dispatch(getCatalogUpdateAutonomousSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeName: AttributeName.AUTONOMOUS
                }))
                dispatch(setCatalogUpdateAutonomousValidate(null))
            } else if (filterName == "Category") {
                dispatch(getCatalogUpdateCategorySave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeName: AttributeName.CATEGORY
                }))
                dispatch(setCatalogUpdateCategoryValidate(null))
            } else if (filterName == "Category Type") {
                dispatch(getCatalogUpdateCategoryTypeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    isEquipment: true,
                    parentIds: [
                        parseInt(catalogItemValues?.category?.value)
                    ],
                    attributeName: AttributeName.CATEGORY_TYPE
                }))
                dispatch(setCatalogUpdateCategoryTypeValidate(null))
            } else if (filterName == "Category2") {
                dispatch(getCatalogUpdateCategory2Save({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    isEquipment: true,
                    parentIds: [
                        parseInt(catalogItemValues?.category?.value)
                    ],
                    attributeName: AttributeName.CATEGORY2
                }))
                dispatch(setCatalogUpdateCategory2Validate(null))
            } else if (filterName == "Type") {
                dispatch(getCatalogUpdateTypeSave({
                    savedBy: userData?.emailId,
                    value: fieldValue?.trim(),
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    isEquipment: true,
                    attributeName: AttributeName.TYPE
                }))
                dispatch(setCatalogUpdateTypeValidate(null))
            }
        } else if ((!isCatalogUpdateNoOfDoorValid && isCatalogUpdateNoOfDoorValid != null)
            || (!isCatalogUpdateYearValid && isCatalogUpdateYearValid != null)
            || (!isCatalogUpdateCapacityValid && isCatalogUpdateCapacityValid != null)
            || (!isCatalogUpdateUpfitValid && isCatalogUpdateUpfitValid != null)
            || (!isCatalogUpdateDriveTrainValid && isCatalogUpdateDriveTrainValid != null)
            || (!isCatalogUpdatePowerTypeValid && isCatalogUpdatePowerTypeValid != null)
            || (!isCatalogUpdateVehicleLevelValid && isCatalogUpdateVehicleLevelValid != null)
            || (!isCatalogUpdateEqClassCodeValid && isCatalogUpdateEqClassCodeValid != null)
            || (!isCatalogUpdateMakeValid && isCatalogUpdateMakeValid != null) ||
            (!isCatalogUpdateStateAvailabilityValid && isCatalogUpdateStateAvailabilityValid != null) ||
            (!isBudgetingPercentOptionsValid && isBudgetingPercentOptionsValid != null) ||
            (!isUsefulLifeOptionsValid && isUsefulLifeOptionsValid != null) ||
            (!isTagsOptionsValid && isTagsOptionsValid != null) ||
            (!isCatalogUpdateProgramStatusValid && isCatalogUpdateProgramStatusValid != null) ||
            (!isCatalogUpdateAnnualHoursValid && isCatalogUpdateAnnualHoursValid != null) ||
            (!isCatalogUpdateDeckSizeValid && isCatalogUpdateDeckSizeValid != null) ||
            (!isCatalogUpdateDeckTypeValid && isCatalogUpdateDeckTypeValid != null) ||
            (!isCatalogUpdateSizeValid && isCatalogUpdateSizeValid != null) ||
            (!isCatalogUpdateLengthValid && isCatalogUpdateLengthValid != null) ||
            (!isCatalogUpdateAutonomousValid && isCatalogUpdateAutonomousValid != null) ||
            (!isCatalogUpdateCategoryValid && isCatalogUpdateCategoryValid != null) ||
            (!isCatalogUpdateCategoryTypeValid && isCatalogUpdateCategoryTypeValid != null) ||
            (!isCatalogUpdateCategory2Valid && isCatalogUpdateCategory2Valid != null) ||
            (!isCatalogUpdateTypeValid && isCatalogUpdateTypeValid != null) ||
            (!isCatalogUpdateVehicleClassValid && isCatalogUpdateVehicleClassValid != null) ||
            (!isCatalogUpdateGroupTypeValid && isCatalogUpdateGroupTypeValid != null) ||
            (!isCatalogUpdateClassTypeValid && isCatalogUpdateClassTypeValid != null) ||
            (!isCatalogUpdateGrossWeightValid && isCatalogUpdateGrossWeightValid != null) ||
            (!isCatalogUpdateTrimValid && isCatalogUpdateTrimValid != null)
            ) {
            let decriptionTxt = (<p>{filterName == AttributeName.VEHICLE_LEVEL  ? AttributeName.ASSIGNMENT_GROUPS : filterName} value given already exists.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: ConfirmationBee,
                title: "INFORMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    setFieldValue("")
                }
            });
            if (filterName == "# of Doors") {
                dispatch(setCatalogUpdateNoOfDoorValidate(null))
            } else if (filterName == "Year") {
                dispatch(setCatalogUpdateYearValidate(null))
            } else if (filterName == "Vehicle Class") {
                dispatch(setCatalogUpdateVehicleClassValidate(null))
            } else if (filterName == "Group Type") {
                dispatch(setCatalogUpdateGroupTypeValidate(null))
            } else if (filterName == "Gross Vehicle Weight Rating") {
                dispatch(setCatalogUpdateGrossWeightValidate(null))
            } else if (filterName == "Trim") {
                dispatch(setCatalogUpdateTrimValidate(null))
            } else if (filterName == "Class Type") {
                dispatch(setCatalogUpdateClassTypeValidate(null))
            } else if (filterName == "Capacity") {
                dispatch(setCatalogUpdateCapacityValidate(null))
            } else if (filterName == "Upfit") {
                dispatch(setCatalogUpdateUpfitValidate(null))
            } else if (filterName == "Drive Train") {
                dispatch(setCatalogUpdateDriveTrainValidate(null))
            } else if (filterName == "Power Type") {
                dispatch(setCatalogUpdatePowerTypeValidate(null))
            } else if (filterName == "Vehicle Level") {
                dispatch(setCatalogUpdateVehicleLevelValidate(null))
            } else if (filterName == "Eq Class Code") {
                dispatch(setCatalogUpdateEqClassCodeValidate(null))
            } else if (filterName == "Make" || filterName == "Manufacturer") {
                dispatch(setCatalogUpdateMakeValidate(null))
            } else if (filterName == "State Availability") {
                dispatch(setCatalogUpdateStateAvailabilityValidate(null))
            } else if (filterName == "Budgeting Percent") {
                dispatch(isBudgetingPercentOptionValid(null))
            } else if (filterName == "Useful Life / Lease Terms") {
                dispatch(isUsefulLifeOptionValid(null))
            } else if (filterName == "Tags") {
                dispatch(isTagsOptionValid(null))
            } else if (filterName == "Program Status") {
                dispatch(setCatalogUpdateProgramStatusValidate(null))
            } else if (filterName == "Annual Hours") {
                dispatch(setCatalogUpdateAnnualHoursValidate(null))
            } else if (filterName == "Deck Size") {
                dispatch(setCatalogUpdateDeckSizeValidate(null))
            } else if (filterName == "Deck Type") {
                dispatch(setCatalogUpdateDeckTypeValidate(null))
            } else if (filterName == "Size") {
                dispatch(setCatalogUpdateSizeValidate(null))
            } else if (filterName == "Length") {
                dispatch(setCatalogUpdateLengthValidate(null))
            } else if (filterName == "Autonomous") {
                dispatch(setCatalogUpdateAutonomousValidate(null))
            } else if (filterName == "Category") {
                dispatch(setCatalogUpdateCategoryValidate(null))
            } else if (filterName == "Category Type") {
                dispatch(setCatalogUpdateCategoryTypeValidate(null))
            } else if (filterName == "Category2") {
                dispatch(setCatalogUpdateCategory2Validate(null))
            } else if (filterName == "Type") {
                dispatch(setCatalogUpdateTypeValidate(null))
            }
        }

    }, [isCatalogUpdateNoOfDoorValid, isCatalogUpdateYearValid, isCatalogUpdateCapacityValid, isCatalogUpdateUpfitValid, isCatalogUpdateDriveTrainValid, isCatalogUpdatePowerTypeValid, isCatalogUpdateVehicleLevelValid, isCatalogUpdateEqClassCodeValid, isCatalogUpdateMakeValid, isCatalogUpdateStateAvailabilityValid, isBudgetingPercentOptionsValid, isUsefulLifeOptionsValid, isTagsOptionsValid, isCatalogUpdateProgramStatusValid, isCatalogUpdateAnnualHoursValid, isCatalogUpdateDeckSizeValid, isCatalogUpdateDeckTypeValid, isCatalogUpdateSizeValid, isCatalogUpdateLengthValid, isCatalogUpdateAutonomousValid, isCatalogUpdateCategoryValid, isCatalogUpdateCategoryTypeValid, isCatalogUpdateCategory2Valid, isCatalogUpdateTypeValid, isCatalogUpdateVehicleClassValid, isCatalogUpdateGroupTypeValid, isCatalogUpdateClassTypeValid, isCatalogUpdateGrossWeightValid, isCatalogUpdateTrimValid])

    const validate = (filterName: any, value: any) => {
        let isValid = true;
        if (value?.trim()?.length == 0 || value == undefined || value == null) {
            setFieldValueError(`Please enter the ${filterName == AttributeName.VEHICLE_LEVEL  ? AttributeName.ASSIGNMENT_GROUPS : filterName}`)
            isValid = false
        } else if (value?.length > 60 && filterName != "Year") {
            setFieldValueError(`${filterName == AttributeName.VEHICLE_LEVEL  ? AttributeName.ASSIGNMENT_GROUPS : filterName} must be less than 60 characters`)
            isValid = false
        } else if (value?.length > 4 && filterName == "Year") {
            setFieldValueError(`${filterName == AttributeName.VEHICLE_LEVEL  ? AttributeName.ASSIGNMENT_GROUPS : filterName} must be less than 4 digits`)
            isValid = false
        } else {
            setFieldValueError("")
        }
        return isValid
    }

    const handleOnChange = (e: any, filterName: any) => {
        if (filterName == "Year" || filterName == "Budgeting Percent") {
            const regEx = /^\d{0,4}(\.\d{1,4})?$/;
            const valArr = e.target.value.split('.')
            const checkNumber = regEx.test(e.target.value);
            if (!checkNumber || valArr.length > 1) {
                return;
            }
        }
        validate(filterName, e.target.value)
        setFieldValue(e.target.value)
    }

    const onClickAdd = () => {
        let isValid = validate(filterName, fieldValue)
        if (isValid) {
            if (filterName == "# of Doors") {
                dispatch(getCatalogUpdateNoOfDoorValidate({
                    subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.NO_OF_DOORS
                }))
            } else if (filterName == "Year") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateYearValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.YEAR
                }))
            } else if (filterName == "Vehicle Class") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateVehicleClassValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.VEHICLE_CLASS
                }))
            } else if (filterName == "Group Type") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateGroupTypeValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.GROUP_TYPE
                }))
            } else if (filterName == "Gross Vehicle Weight Rating") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateGrossWeightValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.GROSS_WEIGHT_RATING
                }))
            } else if (filterName == "Trim") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateTrimValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.TRIM
                }))
            } else if (filterName == "Class Type") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateClassTypeValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.VEHICLE_TYPE
                }))
            } else if (filterName == "Capacity") {
                dispatch(getCatalogUpdateCapacityValidate({
                    subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.TRUCK_SIZE
                }))
            } else if (filterName == "Upfit") {
                dispatch(getCatalogUpdateUpfitValidate({
                    subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.UPFIT_OPTION
                }))
            } else if (filterName == "Drive Train") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateDriveTrainValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.DRIVE_TRAIN
                }))
            } else if (filterName == "Power Type") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdatePowerTypeValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.FUEL_TYPE
                }))
            } else if (filterName == "Vehicle Level") {
                dispatch(getCatalogUpdateVehicleLevelValidate({
                    vehiclelevel: fieldValue?.trim()
                }))
            } else if (filterName == "Make" || filterName == "Manufacturer") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                let isEquipment = selectedAssetType?.assetType?.value !== CONSTANTS.VEHICLE ? AttributeName.MANUFACTURER : AttributeName.MAKE
                dispatch(getCatalogUpdateMakeValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: isEquipment
                }))
            } else if (filterName == "State Availability") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(getCatalogUpdateStateAvailabilityValidate({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.STATE_AVAILABILITY
                }))
            } else if (filterName == "Budgeting Percent") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(validateBudgetingPercentOption({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.BUDGETING_PERCENT
                }))
            } else if (filterName == "Useful Life / Lease Terms") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(validateUsefulLifeOption({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.USEFUL_LIFE_LEASE_TERMS
                }))
            } else if (filterName == "Tags") {
                let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                dispatch(validateTagsOption({
                    subTypeId: parseInt(subTypeId),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.USE_TAG
                }))
            } else if (filterName == "Program Status") {
                dispatch(getCatalogUpdateProgramStatusValidate({
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.PROGRAM_STATUS
                }))
            } else if (filterName == "Annual Hours") {
                dispatch(getCatalogUpdateAnnualHoursValidate({
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.ANNUAL_HOURS
                }))
            } else if (filterName == "Deck Size") {
                dispatch(getCatalogUpdateDeckSizeValidate({
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.DECKSIZE
                }))
            } else if (filterName == "Deck Type") {
                dispatch(getCatalogUpdateDeckTypeValidate({
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.DECK_TYPE
                }))
            } else if (filterName == "Size") {
                dispatch(getCatalogUpdateSizeValidate({
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.SIZE
                }))
            } else if (filterName == "Length") {
                dispatch(getCatalogUpdateLengthValidate({
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.LENGTH
                }))
            } else if (filterName == "Autonomous") {
                dispatch(getCatalogUpdateAutonomousValidate({
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.AUTONOMOUS
                }))
            } else if (filterName == "Category") {
                dispatch(getCatalogUpdateCategoryValidate({
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.CATEGORY
                }))
            } else if (filterName == "Category Type") {
                dispatch(getCatalogUpdateCategoryTypeValidate({
                    subTypeId: parseInt(catalogItemValues?.category?.value),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.CATEGORY_TYPE
                }))
            } else if (filterName == "Category2") {
                dispatch(getCatalogUpdateCategory2Validate({
                    subTypeId: parseInt(catalogItemValues?.category?.value),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.CATEGORY2
                }))
            } else if (filterName == "Type") {
                dispatch(getCatalogUpdateTypeValidate({
                    subTypeId: parseInt(selectedAssetType?.assetType?.id),
                    attributeValue: fieldValue?.trim(),
                    attributeName: AttributeName.TYPE
                }))
            }
        }
    }

    const commonPopupData = (descriptionTxt?: any, title?: any) => {
        setPopupcontentComplete({
            ...PopupcontentComplete,
            titleImg: ConfirmationBee,
            title: title,
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: descriptionTxt,
            outlineBtnText: "Close",
            isSingleConfirmationBtn: true,
            popupOutlinebtnOnclickComplete: () => {
                hideDialogComplete()
                setDeleteTempValue(null)
            }
        });
    }

    useEffect(() => {
        if (isCatalogItemValidForDelete != null || isEqClassValidForDelete != null || isVehicleLevelValidForDelete != null) {
            if (isCatalogItemValidForDelete == true || isVehicleLevelValidForDelete == true || isEqClassValidForDelete == true) {
                validToDelete(deleteTempValue)
            } else if (isCatalogItemValidForDelete == false || isVehicleLevelValidForDelete == false || isEqClassValidForDelete == false) {
                let descriptionTxt = (<p>Unable to delete the {filterName}.  The {filterName} exist for an active catalog item.</p>);
                commonPopupData(descriptionTxt, "INFORMATION")
            } else if (isCatalogItemValidForDelete == 'error' || isVehicleLevelValidForDelete == 'error' || isEqClassValidForDelete == 'error') {
                let decriptionTxt = (<p>Error Occured while validating.</p>);
                commonPopupData(decriptionTxt, "ERROR")
            }
            dispatch(setIsCatalogItemValidDelete(null));
            dispatch(setIsEqClassValidDelete(null));
            dispatch(setIsVehicleLevelValidDelete(null));
        }

    }, [isCatalogItemValidForDelete, isEqClassValidForDelete, isVehicleLevelValidForDelete])

    const validToDelete = (item: any) => {
        if (filterName == "# of Doors") {
            dispatch(getCatalogRemoveNoOfDoor({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Year") {
            dispatch(getCatalogRemoveYear({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Vehicle Class") {
            dispatch(getCatalogRemoveVehicleClass({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Group Type") {
            dispatch(getCatalogRemoveGroupType({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Gross Vehicle Weight Rating") {
            dispatch(getCatalogRemoveGrossWeight({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Trim") {
            dispatch(getCatalogRemoveTrim({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Class Type") {
            dispatch(getCatalogRemoveClassType({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Capacity") {
            dispatch(getCatalogRemoveCapacity({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Upfit") {
            dispatch(getCatalogRemoveUpfit({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Drive Train") {
            dispatch(getCatalogRemoveDriveTrain({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Power Type") {
            dispatch(getCatalogRemovePowerType({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Vehicle Level") {
            dispatch(getCatalogRemoveVehicleLevel({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Eq Class Code") {
            dispatch(getCatalogRemoveEqClassCode({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Make" || filterName == "Manufacturer") {
            dispatch(getCatalogRemoveMake({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "State Availability") {
            dispatch(getCatalogRemoveStateAvailability({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Budgeting Percent") {
            dispatch(deleteBudgetingPercentOption({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Useful Life / Lease Terms") {
            dispatch(deleteUsefulLifeOption({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Tags") {
            dispatch(deleteTagsOption({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Program Status") {
            dispatch(getCatalogRemoveProgramStatus({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Annual Hours") {
            dispatch(getCatalogRemoveAnnualHours({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Deck Size") {
            dispatch(getCatalogRemoveDeckSize({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Deck Type") {
            dispatch(getCatalogRemoveDeckType({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Size") {
            dispatch(getCatalogRemoveSize({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Length") {
            dispatch(getCatalogRemoveLength({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Autonomous") {
            dispatch(getCatalogRemoveAutonomous({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Category") {
            dispatch(getCatalogRemoveCategory({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Category Type") {
            dispatch(getCatalogRemoveCategoryType({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Category2") {
            dispatch(getCatalogRemoveCategory2({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        } else if (filterName == "Type") {
            dispatch(getCatalogRemoveType({
                savedBy: userData?.emailId,
                valueId: item?.value
            }))
        }
    }

    const removeItem = (item?: any) => {
        if (!isAuthorized(permissions.CreateEditCatalog)) return;
        setDeleteTempValue(item)
        if(filterName == 'Vehicle Level'){
            dispatch(getIsVehicleLevelValidDelete({
                savedBy: userData?.emailId,
                valueId: parseInt(item?.value),
                subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId)
            }))
        }else if(filterName == 'Eq Class Code'){
            dispatch(getIsEqClassValidDelete({
                savedBy: userData?.emailId,
                valueId: parseInt(item?.value),
                subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId)
            }))
        }else{
            dispatch(getIsCatalogItemValidDelete({
                savedBy: userData?.emailId,
                valueId: parseInt(item?.value),
                subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId),
                model: filterName == "Model" ? item?.text : null,
                year: filterName == "Year" ? item?.text : null,
                budgetingPercent: filterName == "Budgeting Percent" ? item?.text : null,
                usefulLife: filterName == "Useful Life / Lease Terms" ? item?.text : null,
            }))
        }
    }

    const onToggleChange = (e:any, item?: any) => {
     setIsVehicleCapacityChecked(item)
    }

    return (
        <AddFilter
            filterName={filterName}
            ExistingDropDownValue={ExistingDropDownValue}
            handleOnChange={handleOnChange}
            fieldValue={fieldValue}
            onClickAdd={onClickAdd}
            removeItem={removeItem}
            fieldValueError={fieldValueError}
            hideDialogComplete={hideDialogComplete}
            PopupcontentComplete={PopupcontentComplete}
            onToggleChange = {onToggleChange}
            isShowVehicleCapacityChecked = {isVehicleCapacityChecked}
            catalogItemValues = {catalogItemValues}
        />
    )
}

export default AddFilterContainer;

